// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

type RenderOnMountProps = {|
  children: any,
|};

type RenderOnMountState = {|
  componentMounted: boolean,
|};

/* istanbul ignore next */
class MountedClientOnly extends React.Component<RenderOnMountProps, RenderOnMountState> {
  constructor(props: RenderOnMountProps) {
    super(props);
    this.state = {
      componentMounted: false,
    };
  }

  componentDidMount = () => {
    this.setState({ componentMounted: true });
  };

  render() {
    return this.state.componentMounted ? this.props.children : null;
  }
}

export default MountedClientOnly;
